import { createContext, useState } from "react";

export const CalculationsContext = createContext({
  inputs: {},
  results: {},
  results2: {},
  tableResults: {},
  currency: {},
  calculators: [],
  selectedCalculator: "",
  setInputs: () => {},
  setResults: () => {},
  setResults2: () => {},
  setTableResults: () => {},
  setCurrency: () => {},
  setCalculators: () => {},
  setSelectedCalculator: () => {},
  resetInputs: () => {},
});

function CalculationsContextProvider({ children }) {
  const [inputs, setInputs] = useState({
    loanAmount: 11200,
    options: 0,
    deposit: 0,
    tradeInValue: 0,
    term: 60,
    rate: 10,
    balloon: 0,
    initFee: 0,
    serviceFee: 0,
    extraPayments: [],
    rateChanges: [],
  });

  const [results, setResults] = useState({ instalment: 0, loan: 0, interestPaid: 0, totalPaid: 0 });
  const [results2, setResults2] = useState({ instalment: 0, loan: 0, interestPaid: 0, totalPaid: 0 });

  const [tableResults, setTableResults] = useState({
    instalment: 0,
    loan: 0,
    interestPaid: 0,
    totalPaid: 0,
  });

  const [currency, setCurrency] = useState({
    country: "South Africa",
    name: "South African Rand",
    code: "ZAR",
    locale: "en-ZA",
    language: "English",
  });

  const [calculators, setCalculators] = useState([]);
  const [selectedCalculator, setSelectedCalculator] = useState({});

  function resetInputs() {
    setInputs({
      loanAmount: 11200,
      options: 0,
      deposit: 0,
      tradeInValue: 0,
      term: 60,
      rate: 10,
      balloon: 0,
      initFee: 0,
      serviceFee: 0,
      extraPayments: [],
      rateChanges: [],
    });
  }

  const value = {
    inputs,
    results,
    results2,
    tableResults,
    currency,
    calculators,
    selectedCalculator,
    setInputs,
    setResults,
    setResults2,
    setTableResults,
    setCurrency,
    setCalculators,
    setSelectedCalculator,
    resetInputs,
  };

  return <CalculationsContext.Provider value={value}>{children}</CalculationsContext.Provider>;
}

export default CalculationsContextProvider;
